import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AppNavbar from "../components/common/AppNavbar";

const tocItems = [
  { id: "intro", label: "1. Introduction" },
  { id: "rights", label: "2. Intellectual Property Rights" },
  {
    id: "advertiser-terms",
    label: "3. Advertiser & Contributor Responsibilities",
  },
  { id: "content-rules", label: "4. Content & Compliance Rules" },
  { id: "limitations", label: "5. Limitations of Liability" },
  { id: "cancellation", label: "6. Cancellation & Termination" },
  { id: "indemnity", label: "7. Indemnification" },
  { id: "payments", label: "8. Payments, Pricing & Invoicing" },
  { id: "defaults", label: "9. Default & Debt Collection" },
];

const sectionContent = {
  intro: `Thank you for your interest in BharatAbroad Website/Platform. By using our services, advertisers, blog contributors, and customers agree to comply with the Advertising Terms & Conditions. You are responsible for maintaining the confidentiality of any information obtained through the platform. BharatAbroad reserves the right to modify these terms at any time, effective immediately.`,

  rights: `BharatAbroad Website/Platform owns all intellectual property rights, including the logo, software, site framework, source code, page layouts, integrations, protocols, and stored information. Limited rights may be granted for personal and non-commercial use.`,

  "advertiser-terms": `By placing an advertisement or submitting content, advertisers, agencies, or contributors accept the terms in full:
- You must provide complete and accurate advertising content (text, images, videos, code, etc.) in compliance with BharatAbroad specifications.
- You grant BharatAbroad a worldwide, royalty-free, irrevocable, perpetual license to publish/post submitted advertising.
- Content must be truthful, accurate, and not misleading or unlawful.
- You must comply with all applicable laws and regulations, including those governing data collection, privacy, and advertising practices.`,

  "content-rules": `BharatAbroad reserves the right to reject, cancel, revise, or remove advertisements considered inappropriate, offensive, deceptive, defamatory, obscene, violent, discriminatory, or promoting illegal activities (including drugs, arms trafficking, terrorism, or gambling). Advertisers are responsible for ensuring full compliance with all applicable advertising regulations and standards.`,

  limitations: `BharatAbroad does not guarantee specific visitor numbers, impressions, or continuous availability of the Website/Platform. We are not liable for delays, failures, or damages caused by events beyond our control, including natural disasters, wars, regulatory restrictions, epidemics, sanctions, or network outages.`,

  cancellation: `Advertisers or agencies may cancel advertising with 30 days written notice unless otherwise agreed. BharatAbroad reserves the right to cancel campaigns in case of non-compliance or payment defaults.`,

  indemnity: `Advertisers, agencies, and contributors agree to indemnify BharatAbroad, its officers, employees, contractors, and agents against all costs, damages, and liabilities arising from breaches of these Terms or unlawful acts/omissions. Warranties and indemnities survive contract termination.`,

  payments: `Prices, fees, and rates are quoted in US Dollars, exclusive of taxes. Advertisers must approve quotes in writing and pay invoices on time with valid payment methods. BharatAbroad will issue invoices to the provided contact address/email. Any withholding or additional taxes remain the advertiser’s responsibility.`,

  defaults: `Failure to pay within 90 days of invoice due date authorizes BharatAbroad to engage debt collection agencies and legal counsel under the Fair Debt Collection Practices Act. BharatAbroad reserves the right to suspend or cancel campaigns until payment obligations are resolved.`,
};

const AdvertisingPolicy = () => {
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const offset = 100;
      for (let i = tocItems.length - 1; i >= 0; i--) {
        const section = document.getElementById(tocItems[i].id);
        if (section && window.scrollY + offset >= section.offsetTop) {
          setActiveId(tocItems[i].id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const renderContent = (content) => {
    const lines = content
      .split("\n")
      .map((line) => line.trim())
      .filter(Boolean);
    const isList = lines.every((line) => line.startsWith("-"));

    if (isList) {
      return (
        <ul>
          {lines.map((line, idx) => (
            <li key={idx}>{line.replace(/^-/, "").trim()}</li>
          ))}
        </ul>
      );
    }

    return lines.map((line, idx) => (
      <p key={idx} className="text-muted" style={{ whiteSpace: "pre-line" }}>
        {line}
      </p>
    ));
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-white">
      <AppNavbar />
      <Container
        fluid
        className="py-5 px-3 px-lg-5"
        style={{ maxWidth: "1400px" }}
      >
        <Row>
          <Col lg={9}>
            <h3 className="fw-bold mb-2">
              Advertising / Terms & Conditions – BharatAbroad
            </h3>
            <p className="text-muted mb-5">Last updated Aug 15, 2025</p>

            {tocItems.map(({ id, label }) => (
              <section className="mb-4" id={id} key={id}>
                <h5 className="fw-bold mb-2">{label}</h5>
                {renderContent(sectionContent[id])}
              </section>
            ))}
          </Col>

          <Col lg={3} className="d-none d-lg-block">
            <div className="sticky-top pt-2" style={{ top: "100px" }}>
              <h6 className="text-dark mb-3 fw-bold">Table of contents</h6>
              <ul className="list-unstyled small">
                {tocItems.map(({ id, label }) => (
                  <li className="mb-2" key={id}>
                    <a
                      href={`#${id}`}
                      className={`text-decoration-none ${
                        activeId === id
                          ? "text-primary fw-semibold"
                          : "text-muted"
                      }`}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
              <a href="#top" className="text-muted small d-block mt-3">
                ⬆ Back to top
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AdvertisingPolicy;
